import React from 'react';

export const AdditionalForms = [	
    { label: 'PNC', value: 'U407', optionId: '1'},	
    { label: 'WOS', value: 'U047A', optionId: '2'},	
    { label: '30 Days NOC', value: 'U688A', optionId: '3'},	
];	

  export const FormsList = [
    { label: 'CG2005', value: 'CG2005'},	
    { label: 'CG2010', value: 'CG2010'},	
    { label: 'CG2011', value: 'CG2011', mutuallyExclusive: 'CG2026'},
    { label: 'CG2012', value: 'CG2012'},	
    { label: 'CG2026', value: 'CG2026', mutuallyExclusive: 'CG2011'},	
    { label: 'CG2037', value: 'CG2037'},	
    { label: 'PNC', value: 'U407'},	
    { label: 'WOS', value: 'U047A'},	
    { label: '30 Days NOC', value: 'U688A'}
];	

  export const bankFormList = ["U407-0116: PNC Evdorsement" ,"U047A-0621: WOS Endorsement", "U688A-0813: 30 Days NOC Endorsement"] 